import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Clickable, Surface, Text, useSurfaceColorAtElevation } from '../../atoms';
import { useTheme } from '@emotion/react';
import { useId, forwardRef, } from 'react';
const TextInput = Object.assign(forwardRef(({ hasLabel, leadingLabel, leadingIcon, trailingLabel, trailingIcon, hasSupportingText, trailingSupportingText, leadingSupportingText, containerClassName, inputContainerClassName, onChangeText, isError, ...props }, ref) => {
    const theme = useTheme();
    const inputId = useId();
    return (_jsxs("div", { className: containerClassName, children: [(hasLabel || leadingLabel || trailingLabel) && (_jsxs("div", { css: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '0.4rem',
                    '*:empty::after': {
                        content: `"\u200B"`,
                    },
                }, children: [_jsx(Text.BodySmall, { as: "label", htmlFor: inputId, children: leadingLabel }), _jsx(Text.BodySmall, { as: "label", htmlFor: inputId, children: trailingLabel })] })), _jsxs(Surface, { className: inputContainerClassName, css: {
                    color: theme.color.onSurface,
                    display: 'flex',
                    alignItems: 'center',
                    padding: '1.156rem 1.5rem',
                    borderRadius: theme.shape.medium,
                    gap: '1rem',
                }, children: [leadingIcon, _jsx("input", { ref: ref, ...props, id: inputId, onChange: (event) => {
                            props.onChange?.(event);
                            onChangeText?.(event.target.value);
                        }, css: [
                            theme.typography.body,
                            {
                                color: theme.color.onSurface,
                                flex: 1,
                                width: props.width ?? '20rem',
                                background: 'transparent',
                                border: 'none',
                                padding: 0,
                                '&[type=number]': {
                                    '::-webkit-outer-spin-button': { display: 'none' },
                                    '::-webkit-inner-spin-button': { display: 'none' },
                                    '-moz-appearance': 'textfield',
                                },
                                outline: 'none',
                            },
                        ] }), trailingIcon] }), (hasSupportingText || leadingSupportingText || trailingSupportingText) && (_jsxs("div", { css: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginTop: '0.8rem',
                    '*:empty::after': {
                        content: `"\u200B"`,
                    },
                }, children: [_jsx(Text.BodySmall, { as: "label", htmlFor: inputId, children: leadingSupportingText }), _jsx(Text.BodySmall, { as: "label", htmlFor: inputId, css: isError && { color: theme.color.onErrorContainer }, children: trailingSupportingText })] }))] }));
}), {
    ErrorLabel: (props) => (_jsx(Text.BodySmall, { css: theme => ({ color: theme.color.onErrorContainer }), ...props })),
    LabelButton: (props) => {
        const theme = useTheme();
        return (_jsx(Clickable.WithFeedback, { ...props, css: {
                padding: '0.3rem 1.1rem',
                border: `1px solid ${useSurfaceColorAtElevation(x => x + 8)}`,
                borderRadius: theme.shape.full,
                cursor: 'pointer',
                ':hover': {
                    filter: 'brightness(1.4)',
                },
            }, children: _jsx(Text.BodyLarge, { css: { display: 'contents' }, children: props.children }) }));
    },
});
export default TextInput;
//# sourceMappingURL=TextInput.js.map